import type { FC, ReactNode } from 'react';
import { Card, Box } from '@material-ui/core';

const PanelContent: FC<ReactNode> = ({ children }) => (
  <Box sx={{ mt: 3 }}>
    <Card>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Card>
  </Box>
);

export default PanelContent;
